<template>
    <DefaultHeader currentPage="mobile-apps" />
    <main>
        <PageIntro title="Mobile Apps" :items="apps">
            Cross-platform apps built with Flutter and published on the App Store and Google Play — from games and
            productivity tools to real-time vehicle and battery diagnostics.
        </PageIntro>

        <div class="container-page space-y-6">
            <MobileAppEntry v-for="app in apps" :key="app.id" :app="app" />
        </div>
    </main>

    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/headers/DefaultHeader.vue'
import PageIntro from '@/components/ui/PageIntro.vue'
import MobileAppEntry from '@/components/MobileAppsPage/MobileAppEntry.vue'
import DefaultFooter from '@/components/footers/DefaultFooter.vue'
import { mobileApps } from '@/data/mobileApps'

export default {
    components: {
        DefaultHeader,
        PageIntro,
        MobileAppEntry,
        DefaultFooter
    },
    data() {
        return { apps: mobileApps };
    }
}
</script>
